
export default {
  computed: {
    website() {
      return this.$slots.default[0].text.trim()
    },
  },
}
